import React from 'react';
import {
  Arr
} from '../../../lib/Array.lib';
import {
  NOT,
  YES
} from '../../../lib/Boolean.lib';
import Core from '../../../lib/Core';
import {
  ACCOUNT_ACTION__EDIT_EMPLOYER_SETTINGS,
  EMPLOYER_SUBMISSION_METHOD__ATS,
  ID__ATS_TYPE__ASHBY_API
} from '../../../lib/Definition';
import Employer from '../../../lib/Employer';
import useState from '../../../lib/hooks/useState.hook';
import getEmployerModel from '../../../lib/models/employer';
import {
  Obj
} from '../../../lib/Object.lib';
import getAtsContextProperty from '../../../lib/services/ATS/getAtsContextProperty.fun';
import {
  COLLECTION__EMPLOYERS,
  readLoopbackRecord,
  updateLoopbackRecord
} from '../../../lib/services/BE/loopback.api';
import {
  Str
} from '../../../lib/String.lib';
import {
  joinClassName
} from '../../Layout/Libraries/Theme.lib';
import Box from '../../Layout/Wrappers/Box';
import Button from '../../Layout/Wrappers/Button';
import Dialog from '../../Layout/Wrappers/Dialog';
import Icon from '../../Layout/Wrappers/Icon';
import {
  WarningChipMessage
} from '../../Layout/Wrappers/Message';
import Once from '../../Layout/Wrappers/Once';
import {
  PLACEMENT__BOTTOM_END
} from '../../Layout/Wrappers/StyledTooltip';
import Subtitle from '../../Layout/Wrappers/Subtitle';
import Title from '../../Layout/Wrappers/Title';
import SectionAtsSettings from './SectionAtsSettings';

export const KEY__CONTROLLER__BUTTON__OPEN_EMPLOYER_SETTINGS = 'ButtonOpenEmployerSettings';
export function getControllerButtonOpenEmployerSettings() {
  return Obj(Core.getKeyValue(KEY__CONTROLLER__BUTTON__OPEN_EMPLOYER_SETTINGS));
}

export function setControllerButtonOpenEmployerSettings(controller) {
  Core.setKeyValue(KEY__CONTROLLER__BUTTON__OPEN_EMPLOYER_SETTINGS, controller);
}

export default function ButtonOpenEmployerSettings({
  acl = true,
  employerId = '',
  ...props
}) {
  const instance = React.useRef({});
  const [state, updateState] = useState();
  const { employer = {} } = state;
  const fetchEmployer = async () => updateState({
    employer: Obj(
      await readLoopbackRecord({
        collection: COLLECTION__EMPLOYERS,
        where: { id: employerId },
        fields: [
          'id',
          'name',
          'submissionMethods',
          'atsTypeId',
          'atsUrl',
          'atsContext'
        ],
        limit: 1
      })
    )
  });
  setControllerButtonOpenEmployerSettings({
    state,
    updateState,
    fetchEmployer
  });
  acl = (
    acl &&
    (
      Core.isEmployer() ||
      Core.isAdmin({ action: ACCOUNT_ACTION__EDIT_EMPLOYER_SETTINGS })
    )
  );
  if (NOT(acl)) { return null; }
  const onClickOpenMainDialog = async (event) => updateState({
    openMainDialog: true
  })
  const ID__EMPLOYER__ATS_TYPE = Str(state.employer?.atsTypeId);
  const ID__ATS__USER = getAtsContextProperty({
    entity: employer,
    atsTypeId: ID__EMPLOYER__ATS_TYPE,
    property: 'userId'
  });
  const YES__CONNECTED = YES(ID__ATS__USER);
  const NOT__CONNECTED = NOT(YES__CONNECTED);
  const YES__VISIBLE__BUTTON = YES(
    Arr(employer.submissionMethods).includes(EMPLOYER_SUBMISSION_METHOD__ATS) &&
    (
      Core.isAdmin({ action: ACCOUNT_ACTION__EDIT_EMPLOYER_SETTINGS }) ||
      (employer.atsTypeId === ID__ATS_TYPE__ASHBY_API)
    )
  );
  const YES__OPEN__MAIN_DIALOG = YES(state.openMainDialog);
  return (
    <>
      <Once
        acl={employerId}
        promise={fetchEmployer}
        render={false}
      />
      <Button flat
        acl={YES__VISIBLE__BUTTON}
        className={joinClassName([
          'mr-1',
          NOT__CONNECTED && 'c-orange-darker',
        ])}
        onClick={onClickOpenMainDialog}
        title={
          <Button flat onClick={onClickOpenMainDialog}>
            <Icon
              icon='add'
              className='mr-1 c-inherit'
            />
            <Box column className='align-left'>
              <Title className='c-white m-0'>
                Add API Key
              </Title>
              <Subtitle className='c-white'>
                Configure ATS integration
              </Subtitle>
            </Box>
          </Button>
        }
        placement={PLACEMENT__BOTTOM_END}
      >
        <WarningChipMessage show={NOT__CONNECTED} className='m-0 mr-1'>
          Setup needed
        </WarningChipMessage>
        <Icon
          {...props}
          icon='settings'
          className='c-inherit'
        />
      </Button>
      <Dialog
        open={YES__OPEN__MAIN_DIALOG}
        onClose={(event) => updateState({
          openMainDialog: false
        })}
        // title={compileText(EMPLOYER_SETTINGS__LABELS.page.title, { EMPLOYER__NAME: Str(employer.name) })}
        children={
          <SectionAtsSettings
            acl={YES(employer.id)}
            onChange={async (update) => {
              clearTimeout(instance.current.timeout);
              instance.current.timeout = setTimeout(async () => {
                Employer.cleanCache();
                await updateLoopbackRecord({
                  collection: COLLECTION__EMPLOYERS,
                  id: employerId,
                  model: getEmployerModel({
                    extended: false
                  }),
                  record: update
                });
                await fetchEmployer();
              }, 1000);
            }}
            employerId={employerId}
            innerWrapperProps={{
              className: ''
            }}
          />
        }
        paperStyle={{
          width: Core.isAdmin() ? sizes.l6 : sizes.m6,
          maxWidth: 'calc(100vw - 2rem)'
        }}
      />
    </>
  );
}